import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TeamInviteDialogComponent } from './team-invite-dialog.component';

@NgModule({
  declarations: [
    TeamInviteDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [
    TeamInviteDialogComponent
  ],
  entryComponents: [
    TeamInviteDialogComponent
  ]
})
export class TeamInviteDialogModule { }
